
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import useTooltip from '@/common/composable/useTooltip'

export default defineComponent({
    props: {
        component: {
            type: String as PropType<'router-link' | 'a' | 'div'>,
            default: 'router-link'
        },
        tooltipContent: {
            type: String,
            default: null
        },
        isSidebarClosed: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const { reference, tooltip, isVisible, x, y, strategy, open, close } = useTooltip({
            placement: 'right-end',
            strategy: 'absolute',
            offset: 16,
            autoPlacement: {
                allowedPlacements: ['right-end'],
            },
        })

        const onOpenTooltip = () => {
            if (props.isSidebarClosed) {
                open()
            }
        }

        return {
            reference,
            tooltip,
            isVisible,
            x,
            y,
            strategy,
            onOpenTooltip,
            close
        }
    }
})
